import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  class: "pagination flex-end",
  style: {"margin-top":"10px"}
}

import { ref, watch } from 'vue'
import { t } from '@/plugins/i18n'
import CommonDialog from '@/components/common/CommonDialog.vue'
import STable from '@/components/Table/index.vue'


export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'errorList'],
  emits: ['update:visible'],
  setup(__props, { emit }) {

const props = __props



const cancel = () => {
  emit('update:visible', false)
}
const commit = () => {
  emit('update:visible', false)
}
const pageData = ref({
  page: 1,
  limit: 10,
  total: 0
})

const config = {
  pageSizes: [10, 20, 30, 50],
  pagerCount: '3',
  layout: ' prev, pager, next, sizes, jumper ',
  background: true
}
const columns = [
  {
    label: t('行目'),
    prop: 'line',
    slotName: 'line',
    width: 100
  },
  {
    label: t('列'),
    prop: 'arrange',
    slotName: 'arrange',
    width: 100
  },
  {
    label: t('エラ-メッセ-ジ'),
    prop: 'msg'
  }
]

const _errorList = ref<any>([])

watch(pageData.value, () => {
  _errorList.value = [...props.errorList].slice((pageData.value.page - 1) * pageData.value.limit, pageData.value.page * pageData.value.limit)
})
watch(() => props.errorList, () => {
  _errorList.value = [...props.errorList].slice((pageData.value.page - 1) * pageData.value.limit, pageData.value.page * pageData.value.limit)
  pageData.value.total = props.errorList.length
})

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createBlock(CommonDialog, {
    visible: __props.visible,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    onOk: commit,
    onCancel: cancel,
    title: _unref(t)('ご注意下さい'),
    footer: true,
    width: "600px",
    closeOnClickModal: false,
    onOpened: _cache[3] || (_cache[3] = ($event: any) => (pageData.value.page = 1))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(STable, {
          ref: (_value, _refs) => {
            _refs['STableRef'] = _value
          },
          "table-data": _errorList.value,
          columns: columns,
          showPagination: false,
          "max-height": 800
        }, {
          line: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.line) + _toDisplayString(_unref(t)('行目')), 1)
          ]),
          arrange: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.arrange) + _toDisplayString(_unref(t)('列')), 1)
          ]),
          _: 1
        }, 8, ["table-data"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_pagination, _mergeProps({
            total: pageData.value.total,
            pageSize: pageData.value.limit,
            "onUpdate:pageSize": _cache[0] || (_cache[0] = ($event: any) => ((pageData.value.limit) = $event)),
            currentPage: pageData.value.page,
            "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((pageData.value.page) = $event))
          }, config), null, 16, ["total", "pageSize", "currentPage"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})